export const name = 'viewerManagerStructureApi' as const
